export default __webpack_public_path__ + "static/media/LynxCasual.3fd9d5a4.jpeg";